import LoginPage from "./LoginPage";

const LoginRoute = () => {
  return <LoginPage />;
};

export default LoginRoute;
